import { useFragment } from '@apollo/client';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { pageIdToRouteMapping } from 'src/app/routes/pageIdToRouteMapping';
import { log } from 'src/app/utils/logging';
import { useDraftId } from 'src/app/v2/hooks/useDraftId';
import { urlResolver } from 'src/app/v2/utils/getUrlResolver';
import { DraftFragmentFragmentDoc, type DraftJob } from 'src/graphql/generated';

import { getLastValidPage } from './utils/getLastValidPage';

export const useRedirectToLastValidRoute = () => {
  const navigate = useNavigate();
  const { pathname: currentUrl, search } = useLocation();
  const draftId = useDraftId();
  const { data: draft, complete } = useFragment<DraftJob>({
    fragment: DraftFragmentFragmentDoc,
    from: {
      __typename: 'DraftJob',
      id: draftId,
    },
  });

  useEffect(() => {
    if (complete) {
      const lastValidPage = getLastValidPage(draft);
      const lastValidRoute = pageIdToRouteMapping[lastValidPage];
      const redirectUrl = urlResolver({ path: lastValidRoute });

      if (redirectUrl !== currentUrl) {
        log.info(
          'useRedirectToLastValidRoute | Redirect to the last valid page',
          redirectUrl,
        );

        navigate(
          {
            pathname: redirectUrl,
            search,
          },
          {
            replace: true,
            state: {
              id: redirectUrl,
            },
          },
        );
      }
    }
  }, [currentUrl, draft, navigate, search, complete]);
};
